import React, { useState, useEffect, useRef } from 'react'
import '../AxiomaAuditorcontainer/AxiomaAuditorContainer.scss'
import './AxiomaContainer.scss'
import AxiomaLogo from './AxiomaLogo'
import { MaterialReactTable } from 'material-react-table'
import { IconButton, Button, TextField, Autocomplete, Tooltip } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import FlagIcon from '@mui/icons-material/Flag'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import DownloadIcon from '@mui/icons-material/Download'
import SearchIcon from '@mui/icons-material/Search'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'  
import { Spin } from 'antd'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AxiomaFormContainer from 'src/components/Axioma/AxiomaFormContainer.jsx'
import useQuery from 'src/utils/hooks/useQuery'
import {
  getRepuestosPorCodigoSap,
  getRepuestosExportable,
  getIam,
  getAuthenticate,
  getRepuestosPaginados,
  getMarcas,
  getSegmentos,
  getSubSegmentos,
  getCategorias,
  getSubCategorias,
  getTiposEmbalaje,
  getTiposProteccion,
  getTiposEmpaque,
  getMarcasFabrica,
  getModelosAplicacion,
  getPrioridades,
  putLiberarMaterial,
  putUpdateRevision,
} from 'src/services/axiomaService'

// Etiqueta Sí / No para las columnas booleanas de la tabla
const SiNo = ({ valor }) => (
  <span className={`axioma-lista__sino ${valor ? 'is-si' : 'is-no'}`}>{valor ? 'Sí' : 'No'}</span>
)

// Color de la etiqueta de estado (solo visual)
const ESTADO_TONOS = {
  'PENDIENTE POR ASIGNAR': 'azul',
  ASIGNADO: 'ambar',
  REASIGNADO: 'gris',
  REVISADO: 'turquesa',
  'REVISADO POR AUDITOR': 'verde',
  AUDITADO: 'indigo',
  FINALIZADO: 'verde-oscuro',
}

const AxiomaContainer = ({ isAuditorData = false }) => {
  const query = useQuery()
  const autoOpenCodigoRef = useRef(null)
  const [repuestos, setRepuestos] = useState([])
  const [idUser, setIdUser] = useState(null)
  const [selectedMaterial, setSelectedMaterial] = useState(null)
  const [marcas, setMarcas] = useState([])
  const [subSegmentos, setSubSegmentos] = useState([])
  const [segmentos, setSegmentos] = useState([])
  const [categorias, setCategorias] = useState([])
  const [subCategorias, setSubCategorias] = useState([])
  const [tiposEmbalaje, setTiposEmbalaje] = useState([])
  const [tiposProteccion, setTiposProteccion] = useState([])
  const [tiposEmpaque, setTiposEmpaque] = useState([])
  const [marcasFabrica, setMarcasFabrica] = useState([])
  const [modelosAplicacion, setModelosAplicacion] = useState([])
  const [loadingData, setLoadingData] = useState(false)
  const [estadoFiltro, setEstadoFiltro] = useState('')
  const [marcaFiltro, setMarcaFiltro] = useState('')
  const [categoriaAxFiltro, setCategoriaAxFiltro] = useState('')
  const [prioridadFiltro, setPrioridadFiltro] = useState('')
  const [materialFiltro, setMaterialFiltro] = useState('')
  const [prioridades, setPrioridades] = useState([])
  const [codigoSap, setCodigoSap] = useState('')
  const [pagination, setPagination] = useState({
    paginaActual: 1,
    totalPaginas: 1,
    totalRegistros: 0,
    registrosPorPagina: 1000,
  })

  const fetchModelosAplicacion = async () => {
    const response = await getModelosAplicacion()
    if (response && response.modelos_aplicacion) {
      setModelosAplicacion(response.modelos_aplicacion)
    }
  }

  const fetchTiposProteccion = async () => {
    const response = await getTiposProteccion()
    if (response && response.protecciones) {
      setTiposProteccion(response.protecciones)
    }
  }

  const fetchTiposEmpaque = async () => {
    const response = await getTiposEmpaque()
    if (response && response.empaques) {
      setTiposEmpaque(response.empaques)
    }
  }

  const fetchMarcas = async () => {
    const response = await getMarcas()
    if (response && response.marcas) {
      setMarcas(response.marcas)
      return response.marcas
    }
    return []
  }
  const fetchSubSegmentos = async () => {
    const response = await getSubSegmentos()
    if (response && response.subsegmentos) {
      setSubSegmentos(response.subsegmentos)
      return response.subsegmentos
    }
    return []
  }

  const fetchSegmentos = async () => {
    const response = await getSegmentos()
    if (response && response.segmentos) {
      setSegmentos(response.segmentos)
      return response.segmentos
    }
    return []
  }
  const fetchCategorias = async () => {
    const response = await getCategorias()
    if (response && response.categorias) {
      setCategorias(response.categorias)
      return response.categorias
    }
    return []
  }
  const fetchSubCategorias = async () => {
    const response = await getSubCategorias()
    if (response && response.subcategorias) {
      setSubCategorias(response.subcategorias)
      return response.subcategorias
    }
    return []
  }
  const fetchTiposEmbalaje = async () => {
    const response = await getTiposEmbalaje()
    if (response && response.embalajes) {
      setTiposEmbalaje(response.embalajes)
    }
  }

  const fetchMarcasFabrica = async () => {
    const response = await getMarcasFabrica()
    if (response && response.marcas_fabrica) {
      setMarcasFabrica(response.marcas_fabrica)
    }
  }

  const fetchPrioridades = async () => {
    const response = await getPrioridades()
    if (response && Array.isArray(response)) {
      setPrioridades(response)
    } else if (response && response.success && Array.isArray(response.success)) {
      setPrioridades(response.success)
    }
  }

  const resetAllData = async () => {
    fetchMarcas()
    fetchSubSegmentos()
    fetchCategorias()
    fetchSegmentos()
    fetchSubCategorias()
    fetchTiposEmbalaje()
    fetchTiposProteccion()
    fetchTiposEmpaque()
    fetchMarcasFabrica()
    fetchModelosAplicacion()
    fetchPrioridades()
  }

  useEffect(() => {
    resetAllData()
  }, [])

  const fetchRepuestos = async (estado = null, codigo = null, pagina = 1, marca = null, categoriaAx = null, material = null, prioridad = null) => {
    setLoadingData(true)
    let response
    
    if (codigo) {
      // Búsqueda por código SAP
      response = await getRepuestosPorCodigoSap(codigo)
    } else {
      const estadoQuery = estado === 'TODOS' ? null : estado
      response = await getRepuestosPaginados({
        estado: estadoQuery,
        marca: marca || undefined,
        categoriaAx: categoriaAx || undefined,
        material: material || undefined,
        prioridad: prioridad || undefined,
        pagina,
        registrosPorPagina: pagination.registrosPorPagina,
      })
    }
    
    const repuestosResponse =
      (response && response.repuestos) ||
      (response && response.success && response.success.repuestos) ||
      []

    const meta = response && response.success
    setPagination((prev) => ({
      paginaActual: meta?.pagina_actual || pagina,
      totalPaginas: meta?.total_paginas || prev.totalPaginas,
      totalRegistros: meta?.total_registros_global || prev.totalRegistros,
    }))

    setRepuestos(repuestosResponse)
    setLoadingData(false)
    return repuestosResponse
  }

  // Deep-link: /axioma/auditor?codigo=XXX o /axioma/axiomer?codigo=XXX
  // Busca el material y abre el formulario como si se hubiera consultado a mano.
  useEffect(() => {
    const codigoParam = (query.get('codigo') || '').trim()
    if (!codigoParam || autoOpenCodigoRef.current === codigoParam) return
    autoOpenCodigoRef.current = codigoParam

    const abrirPorCodigo = async () => {
      setCodigoSap(codigoParam)
      setPagination((prev) => ({ ...prev, paginaActual: 1 }))
      const lista = await fetchRepuestos(null, codigoParam)
      if (lista && lista.length > 0) {
        setSelectedMaterial(lista[0])
      } else {
        toast.warning(`No se encontró el material ${codigoParam}`)
      }
    }
    abrirPorCodigo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleEstadoChange = (event, newValue) => {
    const nuevoEstado = newValue || ''
    setEstadoFiltro(nuevoEstado)
    setCodigoSap('')
  }

  const handleMarcaChange = (event, newValue) => {
    const nuevaMarca = newValue ? newValue.id : ''
    setMarcaFiltro(nuevaMarca)
    setCodigoSap('')
  }

  const handleCategoriaAxChange = (event, newValue) => {
    const nuevaCategoriaAx = newValue ? newValue.id : ''
    setCategoriaAxFiltro(nuevaCategoriaAx)
    setCodigoSap('')
  }

  const handlePrioridadChange = (event, newValue) => {
    const nuevaPrioridad = newValue ? newValue.prioridad || newValue : ''
    setPrioridadFiltro(nuevaPrioridad)
    setCodigoSap('')
  }

  const handleRevisarPorFiltros = async () => {
    setCodigoSap('')
    setPagination((prev) => ({ ...prev, paginaActual: 1 }))
    await fetchRepuestos(estadoFiltro || null, null, 1, marcaFiltro || null, categoriaAxFiltro || null, materialFiltro || null, prioridadFiltro || null)
  }


  const handleConsultarCodigoSap = async () => {
    if (codigoSap.trim() === '') {
      toast.warning('Por favor ingrese un código SAP')
      return
    }
    // setEstadoFiltro('')
    // setMarcaFiltro('')
    // setCategoriaAxFiltro('')
    // setMaterialFiltro('')
    setPagination((prev) => ({ ...prev, paginaActual: 1 }))
    await fetchRepuestos(null, codigoSap.trim())
  }

  // eslint-disable-next-line no-unused-vars
  const handleTraerTodo = async () => {
    setCodigoSap('')
    await fetchRepuestos('TODOS')
  }
  const handleOnClose = async () => {
    setSelectedMaterial(null)
    // const codigo = selectedMaterial?.repuesto_codigo_material_sap || codigoSap
    // setSelectedMaterial(null)
    // if (codigo) {
    //   setEstadoFiltro('')
    //   setCodigoSap(codigo)
    //   setPagination((prev) => ({ ...prev, paginaActual: 1 }))
    //   await fetchRepuestos(null, codigo)
    //   return
    // }
    // // Fallback si no hay código disponible
    // if (estadoFiltro) {
    //   await fetchRepuestos(estadoFiltro, null, pagination.paginaActual)
    // }
  }

  const handleResetData = async () => {
    const id = selectedMaterial.repuesto_id
    const codigo = selectedMaterial.repuesto_codigo_material_sap || codigoSap
    if (codigo) {
      // setEstadoFiltro('')
      setCodigoSap(codigo)
      setPagination((prev) => ({ ...prev, paginaActual: 1 }))
    }
    const updatedRepuestos = await fetchRepuestos(null, codigo)

    // Buscar el material actualizado usando los datos frescos
    const updatedMaterial = updatedRepuestos.find(
      (repuesto) => repuesto.repuesto_id === id,
    )

    if (updatedMaterial) {
      setSelectedMaterial(null)
      setSelectedMaterial(updatedMaterial)
    } else {
      console.log('No se encontró el material con ID:', id)
    }
  }

  useEffect(() => {
    const fetchAuthenticate = async () => {
      const response = await getAuthenticate()
      if (response && response.id) {
        setIdUser(response.id)
      }
    }
    fetchAuthenticate()

    const fetchIam = async () => {
      const response = await getIam()
      if (response && response.id) {
        setIdUser(response.id)
      }
    }
    fetchIam()

    // Tanto auditores como no auditores deben usar los filtros correspondientes
    // No se carga nada automáticamente al inicio
  }, [])

  const liberarMaterial = async (row) => {
    const response = await putLiberarMaterial({
      repuestoId: row.original.repuesto_id,
    })
    if (response && response.success) {
      // console.log(response)
    } else {
      console.error('Error al liberar material')
    }
    handleOnClose()
  }

  const finalizarMaterial = async (row, finalizar, retornar, finalizarAuditor) => {
    const material = row.original
    return 
    const data = {
      revision_id: material.revision_id || null,
      repuesto_id: material.repuesto_id || null,
      usuario_id: material.revision_usuario_revisor_id || null,
      estado_revision: finalizar ? 'REVISADO' : retornar ? 'REASIGNADO' : finalizarAuditor ? 'FINALIZADO' : null,
      descripcion_breve: material.revision_descripcion_breve || null,
      descripcion_correcta: material.revision_descripcion_correcta || null,
      observacion: material.revision_observacion || null,
      cambio_etiqueta: material.revision_cambio_etiqueta || null,
      cambio_empaque: material.revision_cambio_empaque || null,
      cambio_descripcion: material.revision_cambio_descripcion || null,
      usuario_auditor_id: finalizar || retornar ? idUser : null,
      comentario_auditor: material.revision_comentario_auditor || null,
      estado_ax: material.revision_estado_ax || null,
      fecha_auditoria: null,
      largo_mm: material.revision_largo_mm || null,
      ancho_mm: material.revision_ancho_mm || null,
      alto_mm: material.revision_alto_mm || null,
      diametro_mm: material.revision_diametro_mm || null,
      peso_g: material.revision_peso_g || null,
      unidad_empaque_recomendada: material.revision_unidad_empaque_recomendada || null,
      uso_aplicacion: material.revision_uso_aplicacion,
      composicion: material.revision_composicion,
      especificaciones_producto: material.revision_especificaciones_producto,
      especificaciones_electricas: material.revision_especificaciones_electricas,
      tipo_empaque_sugerido_id: material.revision_tipo_empaque_sugerido_id,
      tipos_proteccion_ids: material.revision_tipos_proteccion_ids || [],
      embalaje_sugerido_id: material.revision_embalaje_sugerido_id || null,
      marca_sugerida_id: material.revision_marca_sugerida_id || null,
      categoria_sugerida_id: material.revision_categoria_sugerida_id || null,
      subcategoria_sugerida_id: material.revision_subcategoria_sugerida_id || null,
      segmento_sugerido_id: material.revision_segmento_sugerido_id || null,
      subsegmento_sugerido_id: material.revision_subsegmento_sugerido_id || null,
    }
    const response = await putUpdateRevision(data)
    if (response && response.success) {
      toast.success('Material revisado correctamente')
      handleOnClose()
    } else {
      toast.error('Error al finalizar material')
    }
  }

  const descargarExcel = async () => {
    try {
      // Obtener datos exportables desde el endpoint
      const response = await getRepuestosExportable(estadoFiltro)
      
      if (!response || !response.repuestos) {
        toast.error('No se pudieron obtener los datos para exportar')
        return
      }

      const repuestosExportables = response.repuestos


      // Preparar los datos para Excel
      const datosParaExcel = repuestosExportables.map((repuesto) => ({
        'Material': repuesto.repuesto_codigo_material_sap || '',
        'NPF': repuesto.repuesto_npf || '',
        'Prioridad': repuesto.prioridad || repuesto.repuesto_prioridad || '',
        'Fabricante': repuesto.repuesto_fabricante || '',
        'Descripción': repuesto.repuesto_descripcion || '',
        'Cambio de Descripción': repuesto.revision_cambio_descripcion ? 'Sí' : 'No',
        'Descripción Correcta': repuesto.revision_descripcion_correcta || '',
        'Descripción Breve': repuesto.revision_descripcion_breve || '',
        'Categoría': repuesto.categoria_nombre || '',
        'Categoría AX': repuesto.revision_categoria_nombre || '',
        'Subcategoría': repuesto.subcategoria_nombre || '',
        'Subcategoría AX': repuesto.revision_subcategoria_nombre || '',
        'Segmento': repuesto.segmento_nombre || '',
        'Segmento AX': repuesto.revision_segmento_nombre || '',
        'Subsegmento': repuesto.subsegmento_nombre || '',
        'Subsegmento AX': repuesto.revision_subsegmento_nombre || '',
        'Marca': repuesto.marca_nombre || '',
        'Marca AX': repuesto.revision_marca_nombre || '',
        'Estado Original': repuesto.repuesto_estado_m0 || '',
        'Estado AX': repuesto.revision_estado_ax || '',
        'Uso / Aplicación': repuesto.revision_uso_aplicacion || '',
        'Largo (mm)': repuesto.revision_largo_mm || '',
        'Ancho (mm)': repuesto.revision_ancho_mm || '',
        'Alto (mm)': repuesto.revision_alto_mm || '',
        'Diámetro (mm)': repuesto.revision_diametro_mm || '',
        'Peso (g)': repuesto.revision_peso_g || '',
        'Composición del producto': repuesto.revision_composicion || '',
        'Especificaciones Eléctricas': repuesto.revision_especificaciones_electricas || '',
        'Especificaciones Del producto': repuesto.revision_especificaciones_producto || '',
        'Tipo de Empaque': repuesto.revision_empaque_nombre || '',
        'Protección': repuesto.revision_proteccion_nombre || '',
        'Embalaje': repuesto.revision_embalaje_nombre || '',
        'Unidad de empaque actual': repuesto.repuesto_unidad_empaque_actual || '',
        'Unidad de empaque Recomendada': repuesto.revision_unidad_empaque_recomendada || '',
        'Cambio de etiqueta': repuesto.revision_cambio_etiqueta ? 'Sí' : 'No' || '',
        'Cambio de empaque': repuesto.revision_cambio_empaque ? 'Sí' : 'No' || '',
        'Observación': repuesto.revision_observacion || '',
        'Auditor': repuesto.revision_nombre_auditor || '',
        'Axiomer': repuesto.revision_nombre_revisor || '',
        'Fecha creación': repuesto.revision_fecha_creacion || '',
        'Estado': repuesto.estado || '',
        'Homólogos Maestro': repuesto.homologos_maestro_lista || '',
        'Reemplazantes Maestro': repuesto.reemplazantes_maestro_lista || '',
        'Homólogos Sugerido': repuesto.homologos_sugeridos_lista || '',
        'Reemplazantes Sugerido': repuesto.reemplazantes_sugeridos_lista || '',
      }))

      // Crear un nuevo libro de Excel
      const worksheet = XLSX.utils.json_to_sheet(datosParaExcel)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Repuestos')

      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 15 }, // Material
        { wch: 15 }, // NPF
        { wch: 15 }, // Prioridad
        { wch: 20 }, // Fabricante
        { wch: 30 }, // Descripción
        { wch: 20 }, // Cambio de Descripción
        { wch: 30 }, // Descripción Correcta
        { wch: 30 }, // Descripción Breve
        { wch: 20 }, // Categoría
        { wch: 20 }, // Categoría AX
        { wch: 20 }, // Subcategoría
        { wch: 20 }, // Subcategoría AX
        { wch: 20 }, // Segmento
        { wch: 20 }, // Segmento AX
        { wch: 20 }, // Subsegmento
        { wch: 20 }, // Subsegmento AX
        { wch: 20 }, // Marca
        { wch: 20 }, // Marca AX
        { wch: 15 }, // Estado AX
        { wch: 30 }, // Uso / Aplicación
        { wch: 15 }, // Largo (mm)
        { wch: 15 }, // Ancho (mm)
        { wch: 15 }, // Alto (mm)
        { wch: 15 }, // Diámetro (mm)
        { wch: 15 }, // Peso (g)
        { wch: 30 }, // Composición del producto
        { wch: 30 }, // Especificaciones Eléctricas
        { wch: 30 }, // Especificaciones Del producto
        { wch: 20 }, // Tipo de Empaque
        { wch: 20 }, // Protección
        { wch: 20 }, // Embalaje
        { wch: 25 }, // Unidad de empaque actual
        { wch: 25 }, // Unidad de empaque Recomendada
        { wch: 20 }, // Cambio de etiqueta
        { wch: 20 }, // Cambio de empaque
        { wch: 30 }, // Observación
        { wch: 20 }, // Auditor
        { wch: 20 }, // Axiomer
        { wch: 20 }, // Fecha creación
        { wch: 20 }, // Estado
        { wch: 30 }, // Homólogos Maestro
        { wch: 30 }, // Reemplazantes Maestro
        { wch: 30 }, // Homólogos Sugerido
        { wch: 30 }, // Reemplazantes Sugerido
      ]
      worksheet['!cols'] = columnWidths

      // Generar el archivo
      const fechaActual = new Date().toISOString().split('T')[0]
      const nombreArchivo = `Axioma_Repuestos_${fechaActual}.xlsx`
      
      XLSX.writeFile(workbook, nombreArchivo)
      
      toast.success('Excel descargado correctamente')
    } catch (error) {
      console.error('Error al generar el Excel:', error)
      toast.error('Error al descargar el Excel')
    }
  }

  const handlePaginaChange = async (nuevaPagina) => {
    if (nuevaPagina < 1 || nuevaPagina > pagination.totalPaginas) return
    setPagination((prev) => ({ ...prev, paginaActual: nuevaPagina }))
    await fetchRepuestos(estadoFiltro || null, null, nuevaPagina, marcaFiltro || null, categoriaAxFiltro || null, materialFiltro || null, prioridadFiltro || null)
  }

  const columns = [
    // 1. Material
    {
      header: 'Material',
      accessorKey: 'repuesto_codigo_material_sap',
      size: 100,
    },
    // 2. NPF
    {
      header: 'NPF',
      accessorKey: 'repuesto_npf',
      size: 120,
    },
    // 3. Prioridad
    {
      header: 'Prioridad',
      accessorKey: 'prioridad',
      accessorFn: (row) => row.prioridad || row.repuesto_prioridad || '',
      size: 120,
    },
    // 4. Fabricante
    {
      header: 'Fabricante',
      accessorKey: 'repuesto_fabricante',
      size: 120,
    },  
    // 4. Descripción
    {
      header: 'Descripción',
      accessorKey: 'repuesto_descripcion',
      size: 200,
    },
    // 5. Cambio de Descripción
    {
      header: 'Cambio de Descripción',
      accessorKey: 'revision_cambio_descripcion',
      size: 120,
      Cell: ({ row }) => <SiNo valor={row.original.revision_cambio_descripcion} />,
      
    },
    // 6. Descripción Correcta
    {
      header: 'Descripción Correcta',
      accessorKey: 'revision_descripcion_correcta',
      size: 120,
    },
    // 7. Descripción Breve
    {
      header: 'Descripción Breve',
      accessorKey: 'revision_descripcion_breve',
      size: 100,
      Cell: ({ row }) => (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <p>
            {row.original.revision_descripcion_breve &&
              row.original.revision_descripcion_breve.substring(0, 50)  }
          </p>
        </div>
      ),
    },
    // 8. Categoría
    {
      header: 'Categoría',
      accessorKey: 'categoria_nombre',
      size: 120,
    },
    // 9. Categoría AX
    {
      header: 'Categoría AX',
      accessorKey: 'revision_categoria_nombre',
      size: 120,
    },
    // 10. Subcategoría
    {
      header: 'Subcategoría',
      accessorKey: 'subcategoria_nombre',
      size: 130,
    },
    // 11. Subcategoría AX
    {
      header: 'Subcategoría AX',
      accessorKey: 'revision_subcategoria_nombre',
      size: 130,
    },
    // 12. Segmento
    {
      header: 'Segmento',
      accessorKey: 'segmento_nombre',
      size: 130,
    },
    // 13. Segmento AX
    {
      header: 'Segmento AX',
      accessorKey: 'revision_segmento_nombre',
      size: 130,
    },
    // 14. Subsegmento
    {
      header: 'Subsegmento',
      accessorKey: 'subsegmento_nombre',
      size: 150,
    },
    // 15. Subsegmento AX
    {
      header: 'Subsegmento AX',
      accessorKey: 'revision_subsegmento_nombre',
      size: 150,
    },
    // 16. Marca
    {
      header: 'Marca',
      accessorKey: 'marca_nombre',
      size: 120,
    },
    // 17. Marca AX
    {
      header: 'Marca AX',
      accessorKey: 'revision_marca_nombre',
      size: 120,
    },
    // 18. Estado Original
    {
      header: 'Estado Original',
      accessorKey: 'repuesto_estado_m0',
      size: 120,
    },
   
    // 19. Estado AX
    {
      header: 'Estado AX',
      accessorKey: 'revision_estado_ax',
      size: 120,
    },
    // 20. Uso / Aplicación
    {
      header: 'Uso / Aplicación',
      accessorKey: 'revision_uso_aplicacion',
      size: 150,
    },
    // 21. Largo (mm)
    {
      header: 'Largo (mm)',
      accessorKey: 'revision_largo_mm',
      size: 120,
    },
    // 22. Ancho (mm)
    {
      header: 'Ancho (mm)',
      accessorKey: 'revision_ancho_mm',
      size: 120,
    },
    // 23. Alto (mm)
    {
      header: 'Alto (mm)',
      accessorKey: 'revision_alto_mm',
      size: 120,
    },
    // 24. Diámetro (mm)
    {
      header: 'Diámetro (mm)',
      accessorKey: 'revision_diametro_mm',
      size: 120,
    },
    // 25. Peso (g)
    {
      header: 'Peso (g)',
      accessorKey: 'revision_peso_g',
      size: 120,
    },
    // 26. Composición del producto
    {
      header: 'Composición del producto',
      accessorKey: 'revision_composicion',
      size: 180,
    },
    // 27. Especificaciones Eléctricas
    {
      header: 'Especificaciones Eléctricas',
      accessorKey: 'revision_especificaciones_electricas',
      size: 100,
      Cell: ({ row }) => (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <p>
            {row.original.revision_especificaciones_electricas &&
              row.original.revision_especificaciones_electricas.substring(0, 50)}
          </p>
        </div>
      ),
    },
    // 28. Especificaciones Del producto
    {
      header: 'Especificaciones Del producto',
      accessorKey: 'revision_especificaciones_producto',
      size: 200,
      Cell: ({ row }) => (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <p>
            {row.original.revision_especificaciones_producto &&
              row.original.revision_especificaciones_producto.substring(0, 50)}
            {row.original.revision_especificaciones_producto &&
            row.original.revision_especificaciones_producto.length > 50
              ? '...'
              : ''}
          </p>
        </div>
      ),
    },
    // 29. Tipo de Empaque
    {
      header: 'Tipo de Empaque',
      accessorKey: 'revision_empaque_nombre',
      size: 120,
    },
    // 30. Proteccion
    {
      header: 'Proteccion',
      accessorKey: 'revision_proteccion_nombre',
      size: 120,
    },
    // 31. Embalaje
    {
      header: 'Embalaje',
      accessorKey: 'revision_embalaje_nombre',
      size: 120,
    },
    // 32. Unidad de empaque actual
    {
      header: 'Unidad de empaque actual',
      accessorKey: 'repuesto_unidad_empaque_actual',
      size: 150,
    },
    // 33. Unidad de empaque Recomendada
    {
      header: 'Unidad de empaque Recomendada',
      accessorKey: 'revision_unidad_empaque_recomendada',
      size: 180,
    },
    // 34. Cambio de etiqueta
    {
      header: 'Cambio de etiqueta',
      accessorKey: 'revision_cambio_etiqueta',
      size: 150,
      Cell: ({ row }) => <SiNo valor={row.original.revision_cambio_etiqueta} />,
    },
    // 35. Cambio de empaque
    {
      header: 'Cambio de empaque',
      accessorKey: 'revision_cambio_empaque',
      size: 150,
      Cell: ({ row }) => <SiNo valor={row.original.revision_cambio_empaque} />,
    },
    // 36. Observación
    {
      header: 'Observación',
      accessorKey: 'revision_observacion',
      size: 180,
    },
    // 37. Auditor
    {
      header: 'Auditor',
      accessorKey: 'revision_nombre_auditor',
      size: 120,
    },
    // 38. Axiomer
    {
      header: 'Axiomer',
      accessorKey: 'revision_nombre_revisor',
      size: 120,
    },
    // 39. Fecha creación
    {
      header: 'Fecha creación',
      accessorKey: 'revision_fecha_creacion',
      size: 120,
    },
    // 40. Estado (repetido en la imagen, puede ser otro campo)
    // Ya incluido en la posición 18
    // 41. Acciones
     // . Estado
     {
      header: 'Estado',
      accessorKey: 'estado',
      size: 150,
      Cell: ({ row }) => (
        <span
          className={`axioma-lista__estado axioma-lista__estado--${
            ESTADO_TONOS[row.original.estado] || 'neutro'
          }`}
        >
          {row.original.estado}
        </span>
      ),
    },
    {
      header: 'Acciones',
      accessorKey: 'acciones',
      size: 170,
      enableSorting: false,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <div className="axioma-lista__acciones">
          <Tooltip title="Ver material" arrow>
            <IconButton
              size="small"
              onClick={() => {
                setSelectedMaterial(row.original)
              }}
              color="primary"
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>

        {isAuditorData && row.original.estado !== 'PENDIENTE POR ASIGNAR' && row.original.estado !== 'FINALIZADO' && (
            <>
              
              <Tooltip title="Liberar material" arrow>
                <IconButton
                  size="small"
                  onClick={() => {
                    liberarMaterial(row)
                  }}
                  color="warning"
                >
                  <LockOpenIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {row.original.estado !== 'REVISADO POR AUDITOR' && (
                <Tooltip title="Finalizar material" arrow>
                  <IconButton
                    size="small"
                    onClick={() => {
                      finalizarMaterial(row, true)
                    }}
                    color="primary"
                  >
                    <FlagIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
               {row.original.estado === 'REVISADO' && (
                <Tooltip title="Reasignar material" arrow>
                  <IconButton
                    size="small"
                    onClick={() => {
                      finalizarMaterial(row, false, true)
                    }}
                    color="secondary"
                  >
                    <ReplayOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              
              {row.original.estado === 'AUDITADO' && (
                <Tooltip title="Finalizar por auditor" arrow>
                  <IconButton
                    size="small"
                    onClick={() => {
                      finalizarMaterial(row, false, false, true)
                    }}
                    color="success"
                  >
                    <CheckCircleIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </div>
      ),
    },
  ]

  return (
    <div className="axioma-container axioma-container--lista">
      <div className="axioma-header">
        <AxiomaLogo height={24} className="axioma-lista__logo" />
        <div className="axioma-lista__header-acciones">
          <div className="axioma-lista__sap">
            <TextField
              label="Código SAP"
              variant="outlined"
              value={codigoSap}
              onChange={(e) => setCodigoSap(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleConsultarCodigoSap()
                }
              }}
              size="small"
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={handleConsultarCodigoSap}
              className="axioma-lista__boton"
            >
              Consultar
            </Button>
          </div>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={descargarExcel}
            className="axioma-lista__boton"
          >
            Descargar Excel
          </Button>
        </div>
      </div>
      {selectedMaterial && (
        <AxiomaFormContainer
          material={selectedMaterial}
          onClose={() => handleOnClose()}
          onResetData={() => handleResetData()}
          idUser={idUser}
          repuestosData={repuestos}
          marcas={marcas}
          subSegmentos={subSegmentos}
          segmentos={segmentos}
          categorias={categorias}
          subCategorias={subCategorias}
          isAuditor={isAuditorData}
          tiposEmbalaje={tiposEmbalaje}
          tiposProteccion={tiposProteccion}
          tiposEmpaque={tiposEmpaque}
          marcasFabrica={marcasFabrica}
          modelosAplicacionOrigen={modelosAplicacion}
          onResetAllData={() => resetAllData()}
        />
      )}
      <div className="axioma-content">
        <section className="axioma-lista__panel">
          <span className="axioma-lista__etiqueta">Filtros</span>
          <div className="axioma-lista__fila">
            <div className="axioma-lista__campos">
              <Autocomplete
                options={['REVISADO', 'ASIGNADO', 'REASIGNADO', 'AUDITADO', 'FINALIZADO', 'PENDIENTE POR ASIGNAR']}
                value={estadoFiltro || null}
                onChange={handleEstadoChange}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Estado"
                    variant="outlined"
                  />
                )}
                getOptionLabel={(option) => {
                  const estados = {
                    'REVISADO': 'Revisado',
                    'ASIGNADO': 'Asignado',
                    'REASIGNADO': 'Reasignado',
                    'AUDITADO': 'Auditado',
                    'FINALIZADO': 'Finalizado',
                    'PENDIENTE POR ASIGNAR': 'Pendiente por Asignar'
                  }
                  return estados[option] || option
                }}
                isOptionEqualTo={(option, value) => option === value}
              />

              <Autocomplete
                options={marcas}
                value={marcas.find(m => m.id === marcaFiltro) || null}
                onChange={handleMarcaChange}
                size="small"
                getOptionLabel={(option) => option.nombre || ''}
                isOptionEqualTo={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Marca"
                    variant="outlined"
                  />
                )}
              />

              <Autocomplete
                options={categorias}
                value={categorias.find(c => c.id === categoriaAxFiltro) || null}
                onChange={handleCategoriaAxChange}
                size="small"
                getOptionLabel={(option) => option.nombre || ''}
                isOptionEqualTo={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Categoría AX"
                    variant="outlined"
                  />
                )}
              />

              <Autocomplete
                options={prioridades}
                value={prioridades.find(p => (p.prioridad || p) === prioridadFiltro) || (prioridadFiltro ? { prioridad: prioridadFiltro } : null)}
                onChange={handlePrioridadChange}
                size="small"
                getOptionLabel={(option) => option.prioridad || option || ''}
                isOptionEqualTo={(option, value) => (option?.prioridad || option) === (value?.prioridad || value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Prioridad"
                    variant="outlined"
                  />
                )}
              />
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={handleRevisarPorFiltros}
              className="axioma-lista__boton"
            >
              Revisar por filtros
            </Button>
          </div>
        </section>

        {loadingData && (
          <div className="loading-data axioma-lista__cargando">
            <Spin />
          </div>
        )}

        <MaterialReactTable
          columns={columns}
          data={repuestos}
          state={{
            density: 'compact',
          }}
          enableStickyHeader
          enableColumnPinning
          // La paginación del servidor va en la barra superior de la tabla
          renderTopToolbarCustomActions={() =>
            !codigoSap && pagination.totalPaginas > 0 ? (
              <div className="axioma-lista__paginacion">
                <span>
                  Página <b>{pagination.paginaActual}</b> de <b>{Number(pagination.totalPaginas || 0).toLocaleString('es-CO')}</b> ·{' '}
                  <b>{Number(pagination.totalRegistros || 0).toLocaleString('es-CO')}</b> registros
                </span>
                <div className="axioma-lista__paginacion-botones">
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<ChevronLeftIcon />}
                    onClick={() => handlePaginaChange(pagination.paginaActual - 1)}
                    disabled={pagination.paginaActual <= 1 || loadingData}
                  >
                    Anterior
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    endIcon={<ChevronRightIcon />}
                    onClick={() => handlePaginaChange(pagination.paginaActual + 1)}
                    disabled={
                      pagination.paginaActual >= pagination.totalPaginas || loadingData
                    }
                  >
                    Siguiente
                  </Button>
                </div>
              </div>
            ) : null
          }
          muiTopToolbarProps={{
            sx: { minHeight: 'unset', '& > .MuiBox-root': { alignItems: 'center' } },
          }}
          initialState={{
            pagination: {
              pageSize: 20,
            },
            // Estado y Acciones siempre visibles a la derecha (sin taparse entre sí)
            columnPinning: { right: ['estado', 'acciones'] },
          }}
          muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 150px)' } }}
          muiTablePaperProps={{
            elevation: 0,
            sx: { borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden' },
          }}
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: '#f8fafc',
              color: '#475569',
              fontSize: '12px',
              fontWeight: 700,
              borderBottom: '1px solid #e5e7eb',
              // Columnas fijadas (Estado, Acciones) opacas: sin texto de fondo
              '&[data-pinned="true"]': { opacity: 1, '&:before': { backgroundColor: '#f8fafc' } },
            },
          }}
          muiTableHeadProps={{ sx: { opacity: 1 } }}
          muiTableBodyCellProps={{
            sx: {
              fontSize: '12.5px',
              color: '#1f2937',
              '& p': { margin: 0 },
              '&[data-pinned="true"]': { opacity: 1, '&:before': { backgroundColor: '#fff' } },
            },
          }}
          muiTableBodyRowProps={{ hover: true }}
        />
      
      </div>
    </div>
  )
}

export default AxiomaContainer
